export default "__VITE_ASSET__CnO9Oad2__"